export default {
  data () {
    return {
      footerButtonHeight: 65,
      mScrollHeight: 300
    }
  },
  methods: {
    // 改变Scroll高度
    changeScrollHeight: function () {
      this.$nextTick(() => {
        if (this.$refs.myScroll !== undefined) {
          this.mScrollHeight = window.innerHeight - this.calOffsetTop(this.$refs.myScroll.$el)
        }
      })
    },
    calOffsetTop: function (el) {
      if (!el.offsetParent) {
        return el.offsetTop
      } else {
        return el.offsetTop + this.calOffsetTop(el.offsetParent)
      }
    },

    setFooterButtonPad: function () {
      this.$nextTick(() => {
        if (this.$refs.bottomButtons !== undefined) {
          this.footerButtonHeight = this.$refs.bottomButtons.clientHeight
        }
      })
    }
  },
  mounted () {
    this.setFooterButtonPad()
    this.changeScrollHeight()
    window.onresize = () => {
      this.changeScrollHeight()
    }
  }
}
